import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05b0e11e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: { width: '100%', height: '100%', borderRadius: '4px' } }
const _hoisted_2 = {
  key: 0,
  class: "haveDate"
}
const _hoisted_3 = { class: "footer-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_check_outlined = _resolveComponent("check-outlined")!
  const _component_a_calendar = _resolveComponent("a-calendar")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_calendar, {
        value: _ctx.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
        fullscreen: true,
        onSelect: _ctx.handleSelect,
        onDblclick: _ctx.handleDbClick
      }, {
        dateCellRender: _withCtx(({ current: dayjs }) => [
          (_ctx.haveMsg(dayjs))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_check_outlined)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value", "onSelect", "onDblclick"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: _ctx.handleSubmit,
        loading: _ctx.saveLoading
      }, {
        default: _withCtx(() => [
          _createTextVNode("保存")
        ]),
        _: 1
      }, 8, ["onClick", "loading"]),
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: _ctx.handleResetDate,
        loading: _ctx.resetLoading,
        style: {"margin-left":"10px"}
      }, {
        default: _withCtx(() => [
          _createTextVNode("初始化休息日")
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ])
  ], 64))
}